import { put, call, all } from "redux-saga/effects";
import { deleteSongAPI } from "../api/DeleteSongCall";
import {
  deleteSongSuccess,
  deleteSongFailure,
  removeSong,
} from "../actions/songactions";
import { reportError, reportSuccess } from "../actions/erroractions";

export function* deleteSongSaga(action) {
  try {
    const result = yield call(deleteSongAPI, action);

    if (result.ok) {
      yield all([
        put(deleteSongSuccess()),
        put(reportSuccess("Successfully delete song")),
        put(removeSong(action.uniqueName)),
      ]);
    } else {
      yield all([
        put(deleteSongFailure(action.uniqueName)),
        put(reportError(result.message)),
      ]);
    }
  } catch (e) {
    yield all([
      put(deleteSongFailure(action.uniqueName)),
      put(reportError("Unable to access server")),
    ]);
  }
}
